module.exports = new __parcel__URL__("bigjunior.19fe0fa8.jpg").toString();